/**
 * This controller is just so the container can load the name of the product the user doesn't
 * have access to.
 */
class UnauthorizedContainer {
  /**
   * @param {AppErrorHandler} appErrorHandler To silently handle the error in the case the request
   *                                          for the product name fails.
   * @param {Auth}            auth            To request the product name.
   */
  constructor(appErrorHandler, auth) {
    'ngInject';

    /**
     * A local reference for the `appErrorHandler` service.
     * @type {AppErrorHandler}
     */
    this.appErrorHandler = appErrorHandler;
    /**
     * A local reference for the `auth` service.
     * @type {Auth}
     */
    this.auth = auth;
    /**
     * This is where the name of the product will be stored once the request finishes.
     * @type {string}
     */
    this.subtitle = '';
    /**
     * Whether or not the container is requesting the product name.
     * @type {boolean}
     */
    this.loading = true;
  }
  /**
   * When the container gets mounted, if a product was sent, trigger the method to obtain its
   * name, otherwise, just turn off the loading indicator.
   */
  $onInit() {
    if (this.product) {
      this._loadSubtitle();
    } else {
      this.loading = false;
    }
  }
  /**
   * This is the method called when the container gets mounted and a product was sent; it makes
   * the request to obtain the product name and save it on the instance.
   * @access protected
   * @ignore
   */
  _loadSubtitle() {
    this.loading = true;
    this.auth.getApplication(this.product)
    .then(({ title }) => {
      this.subtitle = title;
    })
    .catch((error) => {
      this.appErrorHandler.silent(error);
    })
    .then(() => {
      this.loading = false;
    });
  }
}
/**
 * Show the _"unauthorized screen"_. This is where the users are redirected when they switch from
 * an implementation they have access to, to one they don't.
 * @ngesdoc component
 * @ngname unauthorizedContainer
 * @ngcontroller {@link UnauthorizedContainer}
 * @ngcontainer
 * @ngmodule auth
 * @ngbinding {string} code The name of the product the user can't access to.
 */
export default {
  controller: UnauthorizedContainer,
  template: `
    <unauthorized
      loading="$ctrl.loading"
      subtitle="$ctrl.subtitle"
    ></unauthorized>
  `,
  bindings: {
    product: '@',
  },
};
